export default __webpack_public_path__ + "src/assets/images/landing/320-560/img_bg_2_7_320-1JBx.png";